import Button from './button';
export default Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/button/index.js
// module id = 36
// module chunks = 0